import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as actions from './actions';
import { MspAjaxService } from 'projects/angular-clarity/src/app/services/ajax/msp-ajax.service';

@Injectable()
export class CwmMappingsEffects {
    load$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.loadMspCwmMappings),
            mergeMap(() =>
                this.ajax.get('/api/octiga/v3/msp/cwm/tenant-mappings').pipe(
                    map((items) => actions.loadMspCwmMappingsSuccess({ items })),
                    catchError((error) => of(actions.loadMspCwmMappingsFailure({ error }))),
                ),
            ),
        ),
    );

    update$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.updateMspCwmMappings),
            mergeMap(({ items }) =>
                this.ajax.put('/api/octiga/v3/msp/cwm/tenant-mappings', items).pipe(
                    map(() => actions.updateMspCwmMappingsSuccess({ items })),
                    catchError((error) => of(actions.updateMspCwmMappingsFailure({ error }))),
                ),
            ),
        ),
    );

    constructor(
        private actions$: Actions,
        private ajax: MspAjaxService,
    ) {}
}
